var $46fbd53e8bc70315$exports = {};
$46fbd53e8bc70315$exports = {
    "dismiss": `Elutas\xedt\xe1s`
};


export {$46fbd53e8bc70315$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
